export const Session = {
  set(token: string) {
    if (typeof window !== 'undefined') {
      localStorage.setItem("magik_token", token);
    }
  },
  get(): string | null {
    if (typeof window !== 'undefined') {
      return localStorage.getItem("magik_token");
    }
    return null;
  },
  clear() {
    if (typeof window !== 'undefined') {
      localStorage.removeItem("magik_token");
    }
  }
};